<template>
  <div>
    <form @submit.prevent="saveStoreOpenSchedule">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="xl"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <font-awesome-icon icon="bars" />
          <span class="pl-2">
            {{ input ? 'Edit' : 'Add' }} Outlet Open Schedule
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row class="mt-2">
              <b-col md="2">
                <label>Outlet Code</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('outletCode')}">
                <b-form-input
                  v-model="obj.outletCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="outletCode"
                />
                <small>{{ errors.first('outletCode') }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>Order Type</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('orderType')}">
                <b-form-select
                  v-model="obj.orderType"
                  v-validate="'alpha_num'"
                  name="orderType"
                  :options="getOpenScheduleConfig"
                />
                <small>{{ errors.first('orderType') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2">
                <label>Status</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('status')}">
                <b-form-input
                  v-model="obj.status"
                  v-validate="'required|status'"
                  type="text"
                  name="status"
                />
                <small>{{ errors.first('status') }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>Begin Date</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('beginDate')}">
                <b-form-input
                  v-model.number="obj.beginDate"
                  v-validate="'numeric|max_value:99991231|min_value:10000101|date'"
                  type="text"
                  name="beginDate"
                />
                <small>{{ errors.first('beginDate') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2">
                <label>End Date</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('endDate')}">
                <b-form-input
                  v-model.number="obj.endDate"
                  v-validate="'numeric|max_value:99991231|min_value:10000101|date'"
                  type="text"
                  name="endDate"
                />
                <small>{{ errors.first('endDate') }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>Begin Day</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('beginDay')}">
                <b-form-input
                  ref="beginDay"
                  v-model.number="obj.beginDay"
                  v-validate="`required|numeric|max_value:7|min_value:1|valid_day:${obj.endDay}`"
                  type="text"
                  name="beginDay"
                />
                <small>{{ errors.first('beginDay') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2">
                <label>End Day</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('endDay')}">
                <b-form-input
                  ref="endDay"
                  v-model.number="obj.endDay"
                  v-validate="'required|numeric|max_value:7|min_value:1'"
                  type="text"
                  name="endDay"
                />
                <small>{{ errors.first('endDay') }}</small>
              </b-col>
              <b-col md="1" />
              <b-col md="2">
                <label>Begin Hour</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('beginHour')}">
                <b-form-input
                  ref="beginHour"
                  v-model.number="obj.beginHour"
                  v-validate="`required|numeric|max_value:235959|min_value:0|times|valid_hour:${obj.endHour}`"
                  type="text"
                  name="beginHour"
                />
                <small>{{ errors.first('beginHour') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2">
                <label>End Hour</label>
              </b-col>
              <b-col md="3" :class="{'form-error': errors.first('endHour')}">
                <b-form-input
                  ref="endHour"
                  v-model.number="obj.endHour"
                  v-validate="'required|numeric|max_value:235959|min_value:0|times'"
                  type="text"
                  name="endHour"
                />
                <small>{{ errors.first('endHour') }}</small>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success">
            <font-awesome-icon icon="save" />
            {{ input ? 'Update' : 'Save' }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            <font-awesome-icon icon="times" />Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import _ from 'lodash';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: {}
    };
  },

  computed: {
    getOpenScheduleConfig() {
      return _.values(this.$store.getters.GetOpenScheduleConfig.ORDER_TYPES);
    }
  },

  created() {
    this.$store.dispatch('GetOpenScheduleConfig');
  },

  methods: {
    // add and update records
    saveStoreOpenSchedule() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.input === null) {
            this.$store
              .dispatch('CreateStoreOpenSchedule', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  'Record is created'
                );
                if (res) {
                  this.reset();
                  this.$emit('discard-modal', true);
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          } else {
            this.$store
              .dispatch('UpdateStoreOpenSchedule', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  'Record is updated'
                );
                if (res) {
                  this.reset();
                  this.$emit('discard-modal', true);
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          }
        }
      });
    },
    discardModal() {
      this.reset();
      this.$emit('discard-modal');
    },

    // reset input fields
    reset() {
      if (this.input == null) {
        this.obj = {
          id: '',
          outletCode: '',
          menuItemCode: '',
          status: '',
          beginDate: 10000101,
          endDate: 99991231,
          beginDay: 1,
          endDay: 7,
          beginHour: 0,
          endHour: 235959
        };
      } else {
        this.obj = this.input;
      }
    }
  }
};
</script>
